import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Input,
} from 'reactstrap';
import { GithubPicker } from 'react-color';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';

class SzektorContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      formNev: '',
      formNevEn: '',
      formAzonosito: '',
      formSzinkod: '',
      formAkadalymentesitett: false,
      formHasznalhato: true,
    };
  }

  // componentDidMount() {
  //   this.listSzektor();
  // }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.listSzektor();
    }
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  listSzektor = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listSzektor((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getSzektor = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getSzektor(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formNev: this.nullToString(res[0].nam),
          formNevEn: this.nullToString(res[0].name),
          formAzonosito: this.nullToString(res[0].cod),
          formSzinkod: this.nullToString(res[0].col),
          formAkadalymentesitett: res[0].han,
          formHasznalhato: res[0].use,
          formTobbnyelvuseg: res[0].mln
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getSzektor(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deleteSzektor = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteSzektor(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listSzektor();
        this.props.globals.addSuccess('Szektor törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formNev: '',
      formNevEn: '',
      formAzonosito: '',
      formSzinkod: '',
      formAkadalymentesitett: false,
      formHasznalhato: true
    }, () => {
      this.toggleFormModal();
    });
  }

  submitForm = () => {
    const {
      currentId,
      formNev,
      formNevEn,
      formAzonosito,
      formSzinkod,
      formAkadalymentesitett,
      formHasznalhato,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.cod = this.emptyOrNull(formAzonosito);
      submitObj.nam = this.emptyOrNull(formNev);
      if (this.state.formTobbnyelvuseg) {
        submitObj.name = this.emptyOrNull(formNevEn);
      }
      submitObj.col = this.emptyOrNull(formSzinkod);
      submitObj.han = formAkadalymentesitett;
      submitObj.use = formHasznalhato;

      Services.addSzektor(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Szektor felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listSzektor();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.cod = this.emptyOrNull(formAzonosito);
      submitObj.nam = this.emptyOrNull(formNev);
      if (this.state.formTobbnyelvuseg) {
        submitObj.name = this.emptyOrNull(formNevEn);
      }
      submitObj.col = this.emptyOrNull(formSzinkod);
      submitObj.han = formAkadalymentesitett;
      submitObj.use = formHasznalhato;

      Services.editSzektor(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Szektor módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listSzektor();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        <React.Fragment>
          {this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
      color: this.getCorrectTextColor('#' + szinkod)
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új szektor létrehozása';
      case 'MOD':
        return 'Szektor módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectOptions = {
      true: 'Igen',
      false: 'Nem',
    };

    const columns = [
      {
        dataField: 'cod',
        text: 'Szektor azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nam',
        text: 'Szektor név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'han',
        text: 'Akadálymentesített?',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'use',
        text: 'Használható?',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'col',
        text: 'Szektor szín',
        style: this.styleSzinkod,
        formatter: (cell) => { return '#' + cell; },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR'], true),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

renderForm = () => {
  const {
    formNev,
    formNevEn,
    formAzonosito,
    formSzinkod,
    formAkadalymentesitett,
    formHasznalhato,
    formType
  } = this.state;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
            <RFField
              label={'Azonosító: *'}
              name="formAzonosito"
              id="formAzonosito"
              maxLength="10"
              disabled={formType === 'MOD'}
              type="text"
              value={formAzonosito}
              onChange={this.handleInputChange}
              required
            />
        </div>
        <div className="col-md-12">
            <RFField
              label={'Név: *'}
              name="formNev"
              id="formNev"
              type="text"
              value={formNev}
              onChange={this.handleInputChange}
              required
            />
        </div>
        {this.state.formTobbnyelvuseg
        && (
        <div className="col-md-12">
            <RFField
              label={'Név (angol):'}
              name="formNevEn"
              id="formNevEn"
              type="text"
              value={formNevEn}
              onChange={this.handleInputChange}
            />
        </div>
        )}
        <div className="col-md-12">
            <RFField
              label={'Színkód: *'}
              name="formSzinkod"
              id="formSzinkod"
              type="text"
              value={formSzinkod}
              disabled
              onChange={this.handleInputChange}
              required
            />
        </div>
        <div className="col-md-12">
          <GithubPicker
            color={formSzinkod}
            onChangeComplete={this.handleColorChange}
          />
        </div>
        <div className="col-md-12" style={{ marginTop: 15 }}>
          <RFField
            type="checkbox"
            id="formHasznalhato"
            name="formHasznalhato"
            label="Használható"
            value={formHasznalhato}
            onChange={this.handleInputChange}
          />
        </div>
        <div className="col-md-12" style={{ marginTop: 15 }}>
          <RFField
            type="checkbox"
            id="formAkadalymentesitett"
            name="formAkadalymentesitett"
            label="Akadálymentesített"
            value={formAkadalymentesitett}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          {this.props.globals.hasRole(['JEGYTERMEK_SZEKTOR'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új szektor'}
            </Button>
          )}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.listSzektor(); }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      {/* <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="sm"> */}
        <RFForm
          onSubmit={this.submitForm}
          modalInsert
          title={this.renderFormTitle()}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal, backdrop: 'static', size: 'sm' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {/* <ModalHeader>{this.renderFormTitle()}</ModalHeader>
          <ModalBody> */}
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => {}}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          {/* </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              loading={this.state.saveButtonLoading}
            >
              {'Mentés'}
            </ProgressButton>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
          </ModalFooter> */}
        </RFForm>
      {/* </Modal> */}
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteSzektor()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

SzektorContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default SzektorContent;
